import httpClient from '@/services/httpClient'

const redirectToOldApplication = async (token?: string): Promise<void> => {
  let config = {}

  if (token) {
    config = {
      headers: {
        token,
      },
    }
  }

  const magicLink: string = await httpClient
    .get(
      `/integration/app-paciente/usuario/gerar-link-magico-web-conexa`,
      config,
    )
    .then(({ data }) => data.object)
  window.location.href = magicLink
}

export default redirectToOldApplication
